import { z } from 'zod';
/** 游戏变量条目结构：变量名称与初始值，随项目一起落库并由创作者在创建/编辑时维护。 */
export const gameVariableSchema = z.object({
    name: z.string().trim().min(1).max(30),
    initialValue: z.number().int(),
});
/** 项目列表条目结构，与后端 ProjectItemVO 对齐。 */
export const projectItemSchema = z.object({
    id: z.number(),
    isDraft: z.number().nullable().optional(),
    novelGenerationStrategy: z.enum(['strict', 'branch_adaptation']).nullable().optional(),
    name: z.string(),
    types: z.array(z.string()).nullable().optional(),
    coverUrl: z.string().nullable().optional(),
    description: z.string().nullable().optional(),
    artStyle: z.string().nullable().optional(),
    durationTier: z.string().nullable().optional(),
    screenRatio: z.string().nullable().optional(),
    interactionLevel: z.string().nullable().optional(),
    gameVariables: z.array(gameVariableSchema).nullable().optional(),
    creationMode: z.enum(['inspiration', 'non_standard', 'standard', 'blank']).nullable().optional(),
    creationStatus: z.number().int().nullable().optional(),
    selectedPlanId: z.number().nullable().optional(),
    creationError: z.string().nullable().optional(),
    /** 章节数（cg_script_node 中 chapter 节点），后端批量统计。 */
    chapterCount: z.number().int().nullable().optional(),
    /** 剧情节点数（cg_story_node），后端批量统计。 */
    nodeCount: z.number().int().nullable().optional(),
    /** 发布状态：0-未发布 1-已发布。 */
    publishStatus: z.number().int().nullable().optional(),
    /**
     * 当前登录用户是否为项目负责人（创建人）。
     * 复制项目等操作只对负责人开放，列表页据此禁用入口并给出提示；
     * 历史接口未返回该字段时按 undefined 处理，不误判为无权限。
     */
    isOwner: z.boolean().nullable().optional(),
    createTime: z
        .union([z.string(), z.number(), z.array(z.number())])
        .nullable()
        .optional(),
    updateTime: z
        .union([z.string(), z.number(), z.array(z.number())])
        .nullable()
        .optional(),
});
